<template>
  <div :class="$options.name">
    <v-data-table
      v-if="preparedItems"
      :items="preparedItems"
      :headers="headers"
      :items-per-page="preparedItems.length"
      :loading="loading"
      hide-default-footer
    >
      <template #item.icon="{ item }">
        <div class="level-img-relative">
          <div :class="[`level-line-${item.level}`]" />
          <v-img
            v-if="item.icon"
            :src="item.icon.file.path"
            max-width="32px"
            class="level-img"
            :class="[`level-${item.level}`]"
          />
          <v-icon
            v-else
            class="level-img level-icon"
            :class="[`level-${item.level}`]"
          >
            help
          </v-icon>
        </div>
      </template>

      <template #item.name="{ item }">
        <div
          class="level-name"
          :class="[`level-${item.level}`]"
        >
          {{ item.name }}
        </div>
      </template>

      <template #item.actions="{ item }">
        <div class="data-table-actions">
          <v-btn
            v-if="remove"
            v-permission="remove.permission"
            color="error"
            class="ml-2"
            :class="{ w100: $vuetify.breakpoint.lgAndDown }"
            x-small
            @click="$dialog.show(remove.dialog, { itemId: item.id })"
          >
            <v-icon left>delete</v-icon> Удалить
          </v-btn>

          <v-btn
            v-if="edit"
            v-permission="edit.permission"
            color="light"
            :class="{ w100: $vuetify.breakpoint.lgAndDown }"
            x-small
            @click="$dialog.show(edit.dialog, { item })"
          >
            <v-icon left>edit</v-icon> Редактировать
          </v-btn>
        </div>
      </template>

      <template v-if="pagination" #footer>
        <v-pagination
          :length="pagination.lastPage"
          :total-visible="8"
          :value="pagination.currentPage"
          :disabled="pagination.lastPage === 1"
          color="blue darken-3"
          class="pb-4 pt-4"
          @input="$emit('on-change-page', $event)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>


export default {
  name: 'tree-data-table',
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Object,
      default: null,
    },
    remove: {
      type: Object,
      default: null,
    },
  },
  computed: {
    preparedItems() {
      return this.getChildren([], this.items, 0);
    },
  },
  methods: {
    getChildren(result, item, level) {
      item.forEach(_ => {
        result.push({ ..._, level });
        if (_.children) {
          return this.getChildren(result, _.children, level + 1);
        }
      });
      return result;
    },
  },
};

</script>

<style lang="scss" scoped>

  .data-table-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .w100 {
      width: auto;
      margin: 0 !important;
    }

    .v-icon.v-icon {
      font-size: 16px;
    }
  }

  .level-img-relative {
    position: relative;
  }

  @for $i from 1 through 6 {
    .level-line-#{$i} {
      border-left: 2px dotted #cdcdcd;
      border-bottom: 2px dotted #cdcdcd;
      width: 28px;
      height: 16px;
      position: absolute;
      left: #{$i * 60 - 46}px;
      top: -12px;
    }
    .level-img.level-#{$i} {
      position: absolute;
      left: #{$i * 60}px;
      top: -16px;
      &.level-icon {
        top: -12px;
      }
    }
    .level-name.level-#{$i} {
      margin-left: #{$i * 60}px;
    }
  }
</style>
